export enum EPeriodTableCellEnum {
  Max = 'Max',
  CustomDays = 'CustomDays',
}

export enum EPeriodTableColumns {
  AccountTypeGuid = 'account_type_guid',
  AsseCode = 'asset_code',
  Period = 'period',
  Day = 'day',
  Week = 'week',
  Month = 'month',
  Year = 'year',
  Days = 'days',
  Max = 'max',
}
